package endorh.unican.gcrv

actual object PlatformEditorDefaults {
   actual val canvasBuffersNum = 2
}